import { CourseStructureCategory } from './course-structure-category.model';

export class CourseStructureCategoryCommand {
    name: string;
    type: string;
    sort: number;
    parent: {
        id: string;
    };

    constructor(tempCourseOfferingsCategory: CourseStructureCategory) {
        this.name = tempCourseOfferingsCategory.name;
        this.type = tempCourseOfferingsCategory.type;
        this.sort = tempCourseOfferingsCategory.sort;

        if (tempCourseOfferingsCategory.parent) {
            this.parent = { id: tempCourseOfferingsCategory.parent.id };
        }
    }
}
